import { RedirectError } from 'logard';
import ChatType from '@/shared/constants/ChatType';
import { enumValues } from '@/shared/utils/typescript';

export function validateChatType(value: any): ChatType {
  if (typeof value !== 'string' || !enumValues(ChatType).includes(value as any)) {
    throw new RedirectError({ query: { chat: ChatType.INTERNAL } });
  }
  return value as ChatType;
}
